import { useContext, useEffect, useState } from 'react';
import { Filters } from './Filters';
import { TableComponent } from '../../../../components/Table';
import { Column } from 'primereact/column';
import { StoreContext } from '../../../../context/Provider';
import { formatDateTime } from '../../../../utils/utils';

export const TableDeviceHistory = () => {
  const [sort, setSort] = useState([{ field: '', order: -1 }]);
  const [devices, setDevices] = useState([]);
  const context = useContext(StoreContext);
  const { dispatchLoading, historyDeviceState } = context;


  useEffect(() => {
    setDevices(historyDeviceState.state.data);
  }, [historyDeviceState.state]);

  let defaultColumns = [
    {
      field: 'date',
      header: 'Fecha',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
      body: (rowData: any) => formatDateTime(rowData.date)
    },
    {
      field: 'deviceType',
      header: 'Tipo de dispositivo',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'deviceId',
      header: 'Número de dispositivo',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'project',
      header: 'Proyecto',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'technologicalOperator',
      header: 'Operador tecnológico',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'route',
      header: 'Ruta',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'description',
      header: 'Descripción',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
    {
      field: 'user',
      header: 'Usuario',
      sortable: true,
      width: '100px',
      isFilter: true,
      dataType: undefined,
    },
  ];

  const getColumnsToDisplayIntable = () => {
    let columns = defaultColumns.map((column: any, index: any) => {
      const key = index.toString();
      return (
        <Column
          key={key}
          field={column.field}
          filterField={column.field}
          dataType={column.isFilter ? column.dataType : undefined}
          header={column.header}
          style={{
            flexGrow: 1,
            flexBasis: '100px',
          }}
          bodyClassName={'!text-grey !text-sm'}
          headerClassName={'!text-black !justify-between !bg-white'}
          sortable={column.sortable}
          filterMenuStyle={{ width: '14rem' }}
          filter={false}
          body={column.body}
        />
      );
    });

    return columns;
  };
  return (
    <div className="flex w-full h-full relative flex-col gap-y-2">
      <div className="flex w-full h-24">
         <Filters/>
      </div>

      <div className="h-full flex flex-col w-full overflow-y-auto relative  bg-white rounded-md shadow-lg p-2 ">
        <TableComponent
          value={devices}
          sortField="name"
          responsiveLayout="scroll"
          className="flex h-full w-full  relative rounded"
          globalFilterFields={[]}
          resizableColumns
          setSort={setSort}
          sort={sort}
          paginator
          reorderableColumns={true}
          OnEmptyMessage="No se encontraron registros disponibles."
          loading={false}>
          {getColumnsToDisplayIntable()}
        </TableComponent>
      </div>
    </div>
  );
};
